import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'splicer' })
export class SplicerPipe implements PipeTransform {
  transform(value: any[], page: number, size: number): any[] {
    return [...value].splice(page * size, size);
  }
}
